import { useState, useEffect } from "react";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import ThemeMaker from "../../components/thememaker";
import axios from "axios";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import "../NewmasterPage/Master.css";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import brandStyles from "../Brand/Brand.module.css";
import "../../components/mcrbTableTheme.css";
import styles from "./returnorders.module.css";
const { apiEndpoint } = config;

function statusPillClass(rawStatus: any) {
  const s = (rawStatus || "").toString().toLowerCase();
  if (["delivered", "approved", "paid", "completed"].some((k) => s.includes(k))) return styles.pillGreen;
  if (["cancelled", "canceled", "rejected", "failed", "not-paid", "not paid"].some((k) => s.includes(k))) return styles.pillRed;
  if (["initiated", "picked", "pending"].some((k) => s.includes(k))) return styles.pillAmber;
  if (["shipped", "created"].some((k) => s.includes(k))) return styles.pillBlue;
  return styles.pillGrey;
}

const ReturnOrders = () => {
  const decoded: any = tokenDecode();
  const currentSellerId = decoded?.data?.user?.seller_id;
  const isAdmin = currentSellerId === 1;

  const [returnorderlist, setreturnorderlist] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sellerList, setSellerList] = useState<any[]>([]);
  const [sellerFilterId, setSellerFilterId] = useState("");
  const [dateFilter, setDateFilter] = useState("");

  const returnorder = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/ordersfilter`,
        method: "POST",
        headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
        data: {
          date: dateFilter,
          order_status: ["Cancelled"],
          ...(isAdmin ? (sellerFilterId ? { seller_id: sellerFilterId } : {}) : { seller_id: currentSellerId }),
        },
      });
      if (data.status === 200) {
        setreturnorderlist(data.data || []);
      }
    } catch (error) {
      console.log("error", error);
      toast.error("Error loading return orders");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchSellerList = async () => {
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getsellerlist`,
        method: "GET",
        headers: { "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}` },
      });
      if (data.status === 200) {
        setSellerList(data.data);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    returnorder();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sellerFilterId, dateFilter]);

  useEffect(() => {
    if (isAdmin) fetchSellerList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeMaker>
      <div className={`${styles.pageWrap} mcrb-page`}>
        <div className={`${brandStyles.cardOuter} mcrb-card`}>
          <div className={brandStyles.headerBar}>
            <span className={brandStyles.title}>Return Orders</span>
          </div>

          <div className={styles.toolbarRow}>
            {isAdmin ? (
              <div className={styles.field}>
                <label className={styles.label}>Seller</label>
                <select className={styles.filterSelect} value={sellerFilterId} onChange={(e) => setSellerFilterId(e.target.value)}>
                  <option value="">All Sellers</option>
                  {sellerList.map((item: any) => (
                    <option value={item?.seller_id} key={item?.seller_id}>{item?.company_name}</option>
                  ))}
                </select>
              </div>
            ) : null}
            <div className={styles.field}>
              <label className={styles.label}>Date</label>
              <input type="date" className={styles.dateInput} value={dateFilter} onChange={(e) => setDateFilter(e.target.value)} />
            </div>
            {(sellerFilterId || dateFilter) ? (
              <button type="button" className={styles.clearBtn} onClick={() => { setSellerFilterId(""); setDateFilter(""); }}>
                Clear Filters
              </button>
            ) : null}
          </div>

          <div className={brandStyles.bodyArea} style={{ minHeight: "45vh" }}>
            {isLoading ? (
              <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
                <CircularProgress />
              </div>
            ) : (
              <>
                <div className="productListing_mobile">
                  {returnorderlist.map((item: any, index: any) => (
                    <div className={styles.mobileCard} key={item?.order_id ?? index}>
                      <div className={styles.mobileIndex}>0{index + 1}</div>
                      <div className={styles.mobileBody}>
                        <p className={styles.mobileOrderId}>{item?.order_id}</p>
                        <div className={styles.mobileMetaRow}>
                          <span><b>Customer:</b> {item?.name || "-"}</span>
                        </div>
                        <div className={styles.mobileMetaRow}>
                          <span><b>Items:</b> {item?.item_count}</span>
                        </div>
                        <div className={styles.mobileMetaRow}>
                          <span className={`${styles.pillBase} ${statusPillClass(item?.status)}`}>{item?.status || "-"}</span>
                          <span className={`${styles.pillBase} ${statusPillClass(item?.order_state)}`}>{item?.order_state || "-"}</span>
                        </div>
                        <div className={styles.mobileMetaRow}>
                          <span><b>Created At:</b> {item?.created_at}</span>
                        </div>
                      </div>
                      <div className={styles.mobileActions}>
                        <p className={styles.mobilePrice}>&#8377; {item?.order_total}</p>
                        <div className={styles.mobileActionBtns}>
                          <Link to={`/orderCompleteDetail/${item?.order_id}`} className={brandStyles.iconBtn}>
                            <VisibilityOutlinedIcon style={{ color: "#4c2fb3" }} titleAccess="View" />
                          </Link>
                        </div>
                      </div>
                    </div>
                  ))}
                  {returnorderlist.length === 0 ? <p className="text-center text-muted">No return orders found.</p> : null}
                </div>

                <div className={`productListing_desktop ${styles.tableWrap}`}>
                  <table className={styles.premiumTable}>
                    <thead>
                      <tr>
                        <th role="columnheader">Order ID</th>
                        <th role="columnheader">Customer</th>
                        <th role="columnheader">Payment Status</th>
                        <th role="columnheader">Order State</th>
                        <th role="columnheader">Items</th>
                        <th role="columnheader">Order Total</th>
                        <th role="columnheader">Tracking</th>
                        <th role="columnheader">Created Date</th>
                        <th role="columnheader">Action</th>
                      </tr>
                    </thead>

                    <tbody role="rowgroup">
                      {returnorderlist.map((item: any, index: any) => (
                        <tr key={item?.order_id ?? index} role="row">
                          <td role="cell">{item?.order_id}</td>
                          <td role="cell">{item?.name || "-"}</td>
                          <td role="cell">
                            <span className={`${styles.pillBase} ${statusPillClass(item?.status)}`}>{item?.status || "-"}</span>
                          </td>
                          <td role="cell">
                            <span className={`${styles.pillBase} ${statusPillClass(item?.order_state)}`}>{item?.order_state || "-"}</span>
                          </td>
                          <td role="cell">{item?.item_count}</td>
                          <td role="cell">&#8377; {item?.order_total}</td>
                          <td role="cell">
                            {item?.tracking_url ? (
                              <a href={item.tracking_url} target="_blank" rel="noreferrer" className={styles.trackLink}>Track</a>
                            ) : "-"}
                          </td>
                          <td role="cell">{item?.created_at}</td>
                          <td role="cell">
                            <div className={styles.actionCell}>
                              <Link to={`/orderCompleteDetail/${item?.order_id}`} className={brandStyles.iconBtn}>
                                <VisibilityOutlinedIcon style={{ color: "#4c2fb3" }} titleAccess="View" />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {returnorderlist.length === 0 ? (
                        <tr><td colSpan={9} className="text-center">No return orders found.</td></tr>
                      ) : null}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </ThemeMaker>
  );
};

export default ReturnOrders;
